import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import {
  changeListEditorTitle,
  changeListEditorVisibility,
  submitListEditor,
} from '../actions/list_editor'
import { closeModal } from '../actions/modal'
import { MODAL_LIST_CREATE } from '../constants'
import Button from '../components/button'
import Input from '../components/input'
import Form from '../components/form'
import Text from '../components/text'
import Select from '../components/select'
import Divider from '../components/divider'
import DisplayName from '../components/display_name'
import Avatar from '../components/avatar'
import { me } from '../initial_state'
import ListPreview from '../components/previews/list_preview'

class ListCreate extends React.PureComponent {

  handleOnSubmit = () => {
    this.props.onSubmit(this.props.history)
  }

  render() {
    const {
      value,
      visibility,
      onChange,
      onChangeVisibility,
      account,
      showForm,
      disabled,
    } = this.props

    const isDisabled = !value || disabled

    if (showForm) {
      return (
        <div className={[_s.d, _s.w100PC].join(' ')}>
          <div className={[_s.d, _s.flexRow, _s.mb15, _s.pb10, _s.pt15].join(' ')}>
            <Avatar size={38} account={account} />
            <div className={[_s.d, _s.pl15].join(' ')}>
              <DisplayName account={account} noUsername />
              <Text className={_s.pt2} size='small' color='tertiary'>Admin</Text>
            </div>
          </div>
          
          <Input
            title='New feed title'
            placeholder='My new feed...'
            value={value}
            onChange={onChange}
            maxLength={180}
          />

          <Divider isInvisible isSmall />

          <div className={[_s.d, _s.mt5, _s.mb10, _s.py5].join(' ')}>
            <Text
              htmlFor='list-visibility'
              weight='medium'
              color='primary'
              tagName='label'
            >
              Visibility
            </Text>
            <Text color='secondary' size='small' className={_s.pt10}>
              By default, feeds are private and only you can see who is on a feed. No one else can view your feeds. No one knows that they are on your feed.
            </Text>
            <Text color='secondary' size='small' className={_s.pt5}>
              If you want your feed to be public, then people will be able to subscribe to your feed, share your feed and see who is on your feed.
            </Text>
          </div>
          <Select
            id='list-visibility'
            value={visibility}
            onChange={onChangeVisibility}
            options={[
              {
                value: 'private',
                title: 'Private'
              },
              {
                value: 'public',
                title: 'Public',
              },
            ]}
          />
          <div className={[_s.d, _s.bottom0, _s.left0, _s.right0, _s.borderTop1PX, _s.borderColorSecondary, _s.mt15, _s.posSticky, _s.py10, _s.bgPrimary].join(' ')}>
            <Button
              radiusSmall
              isDisabled={isDisabled}
              onClick={this.handleOnSubmit}
              className={_s.mt15}
            >
              <Text color='inherit' align='center' size='medium' weight='medium'>
                Create feed
              </Text>
            </Button>
          </div>
        </div>
      )
    }

    return (
      <ListPreview />
    )
  }

}

const mapStateToProps = (state) => ({
  value: state.getIn(['list_editor', 'title']),
  visibility: state.getIn(['list_editor', 'visibility']),
  disabled: state.getIn(['list_editor', 'isSubmitting']),
  account: state.getIn(['accounts', me]),
})

const mapDispatchToProps = (dispatch, { isModal }) => ({
  onChange: (value) => dispatch(changeListEditorTitle(value)),
  onChangeVisibility: (e) => dispatch(changeListEditorVisibility(e.target.value)),
  onSubmit: (routerHistory) => {
    if (isModal) dispatch(closeModal(MODAL_LIST_CREATE))
    dispatch(submitListEditor(true, routerHistory))
  },
})

ListCreate.propTypes = {
  value: PropTypes.string,
  visibility: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onChangeVisibility: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  isModal: PropTypes.bool,
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ListCreate))